import React, { Component } from "react";
import Editor from './WyswigEditor'
import { connect } from 'react-redux';

import { Button, Form } from 'react-bootstrap';
import Dropzone from 'react-dropzone'
import alertify from 'alertifyjs';
import { saveBlog, fetchBlogs, fetchCategories, updateBlog } from '../actions/api'
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
import { convertToRaw, convertFromRaw, EditorState } from 'draft-js';

import styles from './Dropzone.module.css'
import Table from './table';
import { renderToString } from 'react-dom/server'


import {
    faEdit,
    faUpload
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const tableSchema = [
    {
        title: 'Id',
        // width: 120,
        data: 'id'
    },
    {
        title: 'Title',
        // width: 180,
        data: 'title'
    },
    {
        title: 'Published',
        // width: 180,
        data: 'published'
    },
    {
        title: 'Created at',
        // width: 180,
        data: 'created_at'
    },
    {
        title: 'Created by',
        // width: 180,
        data: 'created_by'
    },
    {
        title: 'Modified at',
        defaultContent: "N/A",
        data: 'modified_at'
    },
    {
        title: 'Modified by',
        defaultContent: "N/A",
        data: 'modified_by'
    },
    {
        title: "Actions",
        data: null,
        defaultContent: renderToString(<>
            <button title="Edit blog" className="btn btn-primary mr-1 editBlog"><FontAwesomeIcon className="mr-1 ml-1" icon={faEdit} /></button>
            <button title="Publish blog" className="btn btn-success publishBlog"><FontAwesomeIcon className="mr-1 ml-1" icon={faUpload} /></button>
        </>),
        ordering: false
    },
];
class Blogs extends Component {
    constructor(props) {
        super(props);
        this.state = { blogs: null, categories: null, renderInput: false, };
        this.saveBlog = props.saveBlog;
        this.updateBlog = props.updateBlog;
    }
    tableBTNTasks = [{
        className: 'editBlog',
        task: (event) => this.handleEditBlog(event) 
    },
    {
        className: 'publishBlog',
        task: (event) => this.handlePublishBlog(event)
    }]
    saveBlogBody = () => {
        const { title, featuredMediaFile, featuredMediaType, category_id, editorState } = this.state;
        const blogBody = draftToMarkdown(convertToRaw(editorState.getCurrentContent()));
        if (!title || title === "")
            alertify.error("Please fill title.");
        else if (!blogBody || blogBody === "" || blogBody.length < 5)
            alertify.error("Please fill description.");
        else if (!category_id || category_id === 0)
            alertify.error("Please select a category.");
        else {
            const payload = {
                description: blogBody,
                title: title,
                featuredMediaFile: featuredMediaFile,
                featuredMediaType: featuredMediaType,
                featuredMediaFileName: featuredMediaFile.name,
                category_id: category_id
            };
            console.log(payload);
            this.saveBlog(payload);
            this.resetForm();
            this.renderTable();
            // this.setState({ blogBody: content, renderInput:false })
        }
    }
    updateBlogBody = () => {
        const { title, category_id, editorState, blog_id } = this.state;
        const blogBody = draftToMarkdown(convertToRaw(editorState.getCurrentContent()));
        this.updateBlog({ blog_id: blog_id, description: blogBody, title: title, category_id: category_id });
        this.resetForm();
        this.renderTable();
    }

    handlePublishBlog(payload) {
        const blogPayload = {
            blog_id: payload.id,
            task: "PUBLISH"
        }
        this.updateBlog(blogPayload);
        this.resetForm();
        this.renderTable();
    }

    resetForm() {
        const formInitialState = {
            content: "",
            title: "",
            blog_id: null,
            featuredMediaPath: null,
            featuredMediaFile: null,
            featuredMediaString: null,
            category_id: 0,
            editorState: undefined
        }
        this.setState({ ...formInitialState })
    }
    setTitle(e) {
        this.setState({ title: e.target.value })
    }
    setCategory(e) {
        this.setState({ category_id: e.target.value })
    }
    setEditorState(editorState) {
        this.setState({ editorState })
    }
    handleFileDrop(files) {
        const ffile = files[0];
        this.setState({ featuredMediaFile: ffile, featuredMediaType: ffile.type, fileName: ffile.path })
        const reader = new FileReader();
        reader.onload = () => {
            this.setState({ featuredMediaString: reader.result })
        }
        reader.readAsDataURL(ffile);

    }
    handleAddBlog() {
        if (!this.state.renderInput) {
            this.setState({
                renderInput: true,
                isEditing: false
            });
        }
        this.resetForm();
    }
    renderTable() {
        if (this.state.renderInput) {
            this.setState({ renderInput: false });
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.blogs !== this.state.blogs) {
            this.setState({ blogs: nextProps.blogs });
            return false
        }
        if (nextState.blogs !== this.state.blogs) return true

        if (nextProps.categories !== this.state.categories) {
            this.setState({ categories: nextProps.categories });
            return false
        }
        if (nextState.categories !== this.state.categories) return true
        return true
    }


    handleEditBlog(payload) {
        console.log(payload);
        var a = markdownToDraft(payload.description);
        var b = convertFromRaw(a);
        var c = EditorState.createWithContent(b);
        const blogPayload = {
            blog_id: payload.id,
            content: payload.description,
            title: payload.title,
            featuredMediaPath: payload.featured_media,
            featuredMediaType: payload.featured_media_type || 'image/*',
            category_id: payload.category_id,
            editorState: c,

        }
        this.setState({
            ...blogPayload,
            renderInput: true,
            isEditing: true,
            prevBlogState: blogPayload
        })
    }

    componentDidMount() {
        if (this.state.blogs === undefined || this.state.blogs === null)
            this.props.fetchBlogs();

        if (this.state.categories === undefined || this.state.categories === null)
            this.props.fetchCategories();
    }

    render() {
        console.log(this.props);
        var options = [];
        if (this.state.categories)
            options = this.state.categories.map(element => {
                return <option key={element.id} value={element.id}>{element.category_name}</option>
            })
        options.splice(0, 0, <option value="" key="">Select an item</option>);
        const featuredMedia = this.state.featuredMediaString || this.state.featuredMediaPath;
        // Array.prototype.push(], options)

        // console.log(options);
        return (
            <div className="container-fluid">
                <div className="row align-items-center" >
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        {!this.state.renderInput ?
                            <>
                                {/* <div className="row"> */}
                                {/* <div className="col-sm-12"> */}
                                <Table data={this.state.blogs} schema={tableSchema} buttonTasks={this.tableBTNTasks} />
                                {/* </div> */}
                                {/* </div> */}
                            </> :
                            <div className="row align-items-center">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <form>

                                        <div className="row align-items-center" style={{ paddingLeft: '2px' }}>
                                            <div className="col-lg-12 col-sm-12 col-md-12">
                                                <br></br>
                                                <h2 style={{ textAlign: "left" }}>{this.state.isEditing ? "Edit blog" : "Create a blog"}</h2>
                                            </div>

                                        </div>

                                        <div className="row align-items-center">
                                            <div className="col-md-9 col-md-9 col-lg-9 " style={{ padding: '4px' }}>
                                                <div className="shadow-lg p-3 mb-5 bg-white rounded">
                                                    {/* <div class="sc-qZtCU hvPses">
                                            <label for="title" class="sc-fzpjYC gJohPa">Title</label>
                                            <div class="">
                                                <input id="title" name="title" tabindex="0" type="text" placeholder="" autocomplete="new-password" step="1" aria-describedby=" " aria-invalid="false" class="" value="" />

                                            </div>
                                        </div> */}
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Label><b>Title</b></Form.Label>
                                                        <Form.Control type="text" placeholder="Enter title" value={this.state.title} onChange={(e) => this.setTitle(e)} />
                                                    </Form.Group>
                                                    <div>
                                                        <label><b>Content</b></label>
                                                        <Editor editorState={this.state.editorState} handleChange={(e) => this.setEditorState(e)} handleSave={(content) => this.saveBlogBody(content)} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-lg-3 col-md-3 " style={{ padding: '4px' }}>
                                                <div className="shadow-lg p-3 mb-5 bg-white rounded">
                                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                                        <Form.Label><b>Category</b></Form.Label>
                                                        <Form.Control value={this.state.category_id} as="select" onChange={(e) => this.setCategory(e)}>
                                                            {options}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>

                                            </div>
                                        </div>
                                        <h4 style={{ textAlign: "left" }}>Add a featured media</h4>
                                        <div className="shadow-lg p-3 mb-5 bg-white rounded">
                                            <Dropzone onDrop={acceptedFiles => this.handleFileDrop(acceptedFiles)}>
                                                {({ getRootProps, getInputProps }) => (
                                                    <section>
                                                        <div {...getRootProps({ className: 'dropzone' })}>
                                                            <div className={`form-group ${styles.files} ${styles.color}`}>
                                                                <input {...getInputProps()} className={styles.file_input} />
                                                                {/* <div>Drag 'n' drop some files here, or click to select files</div> */}
                                                            </div>
                                                        </div>
                                                    </section>
                                                )}
                                            </Dropzone>
                                            {featuredMedia ?
                                                <>
                                                    {this.state.featuredMediaType.match('image.*') && <img style={{ width: "80vmin" }} src={featuredMedia} alt="loading..." />}
                                                    {this.state.featuredMediaType.match('video.*') && <video controls src={featuredMedia} style={{ width: "80vmin" }} type="video/mp4" />
                                                        //                       <p>Your browser doesn't support HTML5 video. Here is
                                                        //  a <a href="myVideo.mp4">link to the video</a> instead.</p> 
                                                        //                     </video>
                                                    }
                                                </>
                                                : <span>No media added</span>}
                                        </div>

                                    </form>
                                </div>
                                <div className="row align-items-center">
                                    <div className="col-sm-12 col-md-12 col-lg-12 justify-content-end">
                                        <div className="">
                                            {/* <Button variant="cancel" style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", fontWeight: 600 }}>Reset</Button> */}
                                            {this.state.isEditing ?
                                                <Button variant="success" style={{ minWidth: "150px", fontWeight: 600 }} onClick={this.updateBlogBody}>Update</Button> :
                                                <Button variant="success" style={{ minWidth: "150px", fontWeight: 600 }} onClick={this.saveBlogBody}>Save</Button>
                                            }
                                            <Button onClick={() => this.renderTable()} variant="danger" style={{ minWidth: "150px", fontWeight: 600 }}>View Blogs</Button>
                                        </div>
                                    </div>
                                </div>
                            </div >}
                    </div>
                </div>

            </div >

        );
    }
}
const mapStateToProps = ({ reducer: store }) => ({
    blogs: store.blogs,
    categories: store.categories,

});

const mapDispatchToProps = {
    saveBlog: saveBlog,
    fetchBlogs: fetchBlogs,
    fetchCategories: fetchCategories,
    updateBlog: updateBlog,
};

export default connect(mapStateToProps, mapDispatchToProps)(Blogs);